module.exports = __webpack_public_path__ + "static/media/Desktop4.4df62c3a.jpg";